// extracted by mini-css-extract-plugin
export default {"activeKpi":"src-views-analytics-components-RevenueKPI-RevenueKPI__activeKpi--Dcddd"};